'use client';

import { FinanceWizardPanel } from '@/components/event-wizard/FinanceWizardPanel';
import type {
  FinanceFieldErrors,
  FinanceFormState,
  PaymentMethodOption,
} from '@/components/event-wizard/finance-wizard-utils';

type Props = {
  form: FinanceFormState;
  onChange: (form: FinanceFormState) => void;
  fieldErrors?: FinanceFieldErrors;
  paymentMethodOptions?: PaymentMethodOption[];
};

export function EventWizardFinanceFields({
  form,
  onChange,
  fieldErrors = {},
  paymentMethodOptions,
}: Props) {
  return (
    <div className="space-y-6">
      <FinanceWizardPanel
        form={form}
        onChange={onChange}
        fieldErrors={fieldErrors}
        paymentMethodOptions={paymentMethodOptions}
      />
    </div>
  );
}
